export default __webpack_public_path__ + "static/agustina-c6c066f5c8d865916cd4868e632b2806.png";